module.exports = __webpack_public_path__ + "img/delete.8da97a2a.svg";